import { Mode } from '@amzn/awsui-global-styles';
import { faMoon, faSun } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { APP_NAME, USER_IMG_BASE_URL } from '../../constants/appConstants';
import { NAV_ITEMS } from '../../constants/routingConstants';
import { getUserTypeDisplayName } from '../../constants/userTypes';
import { useAuth } from '../../contexts/AuthContext';
import { useTheme } from '../../contexts/ThemeContext';
import { usePermissions } from '../../hooks/usePermissions';
import VerityLogo from '../../images/Verity-logo-w-name.png';
import { getUserAccessFlags } from '../../utils/authUtils';
import { navigatePreservingParams } from '../../utils/navigationUtils';
import GlobalSearchBar from './GlobalSearchBar';
import './TopNav.scss';

const TopNav = (): React.ReactElement => {
  const navigate = useNavigate();
  const { user, isAuthenticated } = useAuth();
  const { isInitiallyDeveloper } = getUserAccessFlags(user);
  const { mode, setMode } = useTheme();
  const { userPermission, isTechAdmin } = usePermissions();

  return (
    <nav className="verity-top-nav" aria-label="Main navigation">
      <div className="verity-top-nav__left">
        <a
          href={NAV_ITEMS.HOME.href}
          className="verity-top-nav__logo-link"
          onClick={(e) => {
            e.preventDefault();
            navigatePreservingParams(navigate, NAV_ITEMS.HOME.href);
          }}
          aria-label={`${APP_NAME} Home`}
        >
          <img src={VerityLogo} alt={`${APP_NAME} Logo`} className="verity-top-nav__logo" />
        </a>
      </div>

      <div className="verity-top-nav__center">
        <GlobalSearchBar />
      </div>

      <div className="verity-top-nav__right">
        {isAuthenticated && user && (
          <>
            {isInitiallyDeveloper && !isTechAdmin && userPermission && (
              <span className="verity-top-nav__dev-override">
                ⚠️ Testing as: {getUserTypeDisplayName(userPermission.user_type)}
              </span>
            )}

            <button
              className="verity-top-nav__utility-btn"
              onClick={() => setMode(mode === Mode.Dark ? Mode.Light : Mode.Dark)}
              aria-label={`Switch to ${mode === Mode.Dark ? 'light' : 'dark'} mode`}
            >
              <FontAwesomeIcon icon={mode === Mode.Dark ? faMoon : faSun} />
            </button>

            <div className="verity-top-nav__avatar-dropdown">
              <img
                src={`${USER_IMG_BASE_URL}${user.userAlias}`}
                alt={user.displayName}
                className="verity-top-nav__avatar"
              />
            </div>
          </>
        )}
      </div>
    </nav>
  );
};

export default TopNav;
